import { render, staticRenderFns } from "./ViewPhotoalbumPage.vue?vue&type=template&id=4d149d82&scoped=true&"
import script from "./ViewPhotoalbumPage.vue?vue&type=script&lang=js&"
export * from "./ViewPhotoalbumPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewPhotoalbumPage.vue?vue&type=style&index=0&id=4d149d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d149d82",
  null
  
)

export default component.exports